// extracted by mini-css-extract-plugin
module.exports = {"cta":"WhitelabelLockComponent_cta__2mwpb"};